export interface AboutInfo {
  brandName: string;
  brandIntro: string;
  mission: string;
  vision: string;
  history: {
    year: string;
    event: string;
  }[];
  reputation: {
    title: string;
    value: string;
    icon: string;
  }[];
  contact: {
    address: string;
    email: string;
    phone: string;
    workingHours: string;
    wechat: string;
    qq: string;
  };
}

export const aboutInfo: AboutInfo = {
  brandName: '每日大赛Yandex',
  brandIntro: '每日大赛Yandex是Yandex旗下官方竞技平台推出的每日在线赛事品牌。自2020年创立以来，我们致力于为全球用户提供公平、有趣、具有挑战性的每日竞技体验。平台累计注册用户超过500万，日均参赛人数突破10万，已成为全球最受欢迎的在线竞技平台之一。我们坚信，每个人都有展现自我、挑战极限的权利，每日大赛就是你绽放光彩的舞台。',
  mission: '让每个人都能在公平的竞技环境中挑战自我、收获成长与快乐',
  vision: '成为全球最具影响力的在线竞技平台，连接亿万热爱挑战的灵魂',
  history: [
    { year: '2020', event: 'Yandex每日大赛项目正式立项，开启内部测试' },
    { year: '2021', event: '面向全球用户开放，首月注册用户突破50万' },
    { year: '2022', event: '推出五维评分体系，赛事公平性大幅提升' },
    { year: '2023', event: '日均参赛人数突破5万，平台全面升级AI防作弊系统' },
    { year: '2024', event: '注册用户突破500万，年度总决赛奖金池达50万元' },
    { year: '2025', event: '全新赛季改版，引入挑战者模式与联动合作' },
  ],
  reputation: [
    { title: '累计注册用户', value: '500万+', icon: 'ri-user-star-line' },
    { title: '日均参赛人数', value: '10万+', icon: 'ri-group-line' },
    { title: '覆盖国家和地区', value: '200+', icon: 'ri-global-line' },
    { title: '累计发放奖金', value: '5000万+', icon: 'ri-money-cny-circle-line' },
    { title: '用户满意度', value: '98.7%', icon: 'ri-heart-line' },
    { title: '响应速度', value: '30分钟内', icon: 'ri-timer-flash-line' },
  ],
  contact: {
    address: '北京市海淀区中关村科技园区Yandex大厦18层',
    email: 'support@yandex-contest.cn',
    phone: '400-888-9999',
    workingHours: '周一至周日 9:00 - 22:00（全年无休）',
    wechat: 'yandex_contest_official',
    qq: '88886666',
  },
};